const deleteWorkspace = {
  bindings: {
    workspace: '<',
    mode: '<',
    onSubmit: '&',
    onCancel: '&'
  },
  templateUrl:
    '/modules/pis-tool/workspaces/workspace-modal/delete-workspace/delete-workspace.html',
  controller: 'DeleteWorkspaceController',
};

angular
  .module('pis-tool.module')
  .component('deleteWorkspace', deleteWorkspace);
